// import jQuery from 'CommonScripts/jquery-1.10.2'; 
/* CUSTOM CODE */
(function (window, document, $) {

    $(document).ready(function() {

        var delayTime = $("#hfDelayTime").val() === "" ? 1000 : $("#hfDelayTime").val();
        var isShowedPopup = $("#hfShowPopup").val();


        $("#geo_content .close, #geo_overlay").on("click",
            function() {
                $('#geo_module').hide();
                $("html").css("overflow-y", "auto");
            });

        if (isShowedPopup === "True") {

            setTimeout(function() {
                    showCountrySelectorPopup();
                },
                delayTime);
        }


    });
})(window, document, jQuery);

var showCountrySelectorPopup = function() {
    jQuery('#geo_module').show();
    jQuery("html").css("overflow-y", "hidden");
}